<template>
	<div class="tab">
		<div class="tabBox">
			<div class="logoWrapper">
				<img width="57px" src="../../common/image/logo.png" />
				<h1 class="text_notion">NOTION</h1>
				<div style="color:#fff;line-height:60px;font-size:20px;font-weight:600;padding-left:10px;">information</div>
			</div>
			<div class="menuWrapper">
				<div class="routerWrapper" ref="menu" @click.stop="selectMenu" v-if='menuArr.length>0'>
					<router-link tag='div' class='tab-item' to='/home'>
						<span class='tab-link'>{{this.menuArr[0].name.toUpperCase()}}</span>
					</router-link>
					<router-link tag='div' class='tab-item' to='/products'>
						<span class='tab-link'>{{this.menuArr[1].name.toUpperCase()}}</span>
					</router-link>
					<router-link tag='div' class='tab-item' to='/about'>
						<span class='tab-link'>{{this.menuArr[2].name.toUpperCase()}}</span>
					</router-link>
					<router-link tag='div' class='tab-item' to='/contact'>
						<span class='tab-link'>{{this.menuArr[3].name.toUpperCase()}}</span>
					</router-link>
					<router-link tag='div' class='tab-item' to='/certificate'>
						<span class='tab-link'>{{this.menuArr[4].name.toUpperCase()}}</span>
					</router-link>
					<a class='tab-item' :href='menuArr[5].link' target='_blank'>
						<span class='tab-link'>{{this.menuArr[5].name.toUpperCase()}}</span>
					</a>	
					<router-link tag='div' class='tab-item' to='/source'>
						<span class='tab-link'>{{this.menuArr[6].name.toUpperCase()}}</span>
					</router-link>				
				</div>
			</div>
			<div class="menuIcon" ref="menuIcon" @click="miniMenu">
				<i class="icon iconfont icon-menu" ref="icon"></i>
			</div>
			<div class="langWrapper">
				<span :class='{on:lang==="en"}' @click='selectLanguage("en")'>English</span> / 
				<span :class='{on:lang==="cn"}' @click='selectLanguage("cn")'>中文</span>
			</div>
		</div>		
	</div>
</template>

<script type="text/ecmascript-6">
import animations from 'create-keyframe-animation'
import {getMenu} from 'api/home'
import {mapGetters,mapMutations} from 'vuex'
import {addClass,removeClass} from 'common/js/dom'
import {setLanguage} from 'common/js/cache'

export default{
	data() {
		return {
			isShowMenu:false,
			menuArr:[]
		}
	},
	mounted() {
		setTimeout(()=>{
			this._getMenu()
		},20)		
	},
	methods:{
		miniMenu() {
			if(!this.isShowMenu){
				this.showMenu()
			}else{			
				this.closeMenu()
			}
		},
		_getMenu() {
			getMenu(this.lang).then((res) => {
				this.menuArr = res
			})
		},
		selectMenu() {
			if(this.isShowMenu && this.windowW<=900){
				this.closeMenu()
			}			
		},
		selectLanguage(val) {
			this.setLang(val)
			setLanguage(val)
		},
		showMenu() {
			this.$refs.menu.style.display = 'block'
			removeClass(this.$refs.icon,'icon-menu')
			addClass(this.$refs.icon,'icon-close')
			let animation = {
	          	0:{height:`0px`},
	          	100:{height:`${(this.$refs.menu.children.length)*56}px`}
	        }
	        animations.registerAnimation({
	          	name:'show',
	          	animation,
	          	presets:{
	            	duration:400,
	            	easing:'linear'
	          	}
	        })
    		animations.runAnimation(this.$refs.menu,'show')
    		setTimeout(()=>{
    			this.$refs.menu.style.animation = "none"
    		},400)
    		
			this.isShowMenu = true
		},
		closeMenu() {
			let animation = {
		        0:{height:`${(this.$refs.menu.children.length)*56}px`},
	          	100:{height:`0px`}
	        }
	        animations.registerAnimation({
	          	name:'hide',
	          	animation,
	          	presets:{
	            	duration:400,
	            	easing:'linear'
	          	}
	        })
    		animations.runAnimation(this.$refs.menu,'hide')
    		setTimeout(()=>{
				removeClass(this.$refs.icon,'icon-close')
				addClass(this.$refs.icon,'icon-menu')
				this.$refs.menu.style.display = 'none'	
    			this.$refs.menu.style.animation = "none"
    		},400)
			this.isShowMenu = false
		},
		...mapMutations({
			'setLang':'SET_LANG'
		})
	},
	computed:{
		...mapGetters([
			'windowW',
			'lang'
		])
	},
	watch:{
		windowW(newVal,oldVal) {
			if(newVal<=1000){
				this.$refs.menu.style.display = 'none'
			}else{
				this.$refs.menu.style.display = 'flex'
			}
		},
		lang() {
			this._getMenu()
		}
	}
}
</script>

<style lang="stylus" scoped rel="stylesheet/stylus">
@import "~common/stylus/variable"

.tab
	min-width:$minWidth
	width:100%
	height:60px
	position:fixed
	top:0
	left:0
	z-index:1000
	background-color:$cb-d
	.tabBox
		min-width:760px
		height:100%;
		width:90%
		margin-left:10%
		box-sizing:border-box
		.logoWrapper
			height:100%
			width:25%
			min-width:185px
			margin-right:10px
			display:flex
			flex:1
			float:left
			img
				margin:4px 10px
				display:block
			.text_notion
				color:$fc1
				display:block
				line-height:60px
				font-size:$logo-text 
				font-weight:600
		.menuWrapper
			min-width:570px
			display:inline-block
			.routerWrapper
				display:flex
				flex:1				
				.tab-item	
					display:block	
					padding:0 15px
					height:55px
					.tab-link
						display:block
						line-height:60px
						color:$fc1
						font-size:$fs-medium-x
					&.router-link-active
						.tab-link
							color:$fc2
				.tab-item:hover
					&.tab-item
						background-image: linear-gradient(180deg,#38577a,#2d455f)
						border-bottom:5px solid $fc2
						.tab-link
							color:$fc1
		.langWrapper
			float:right
			font-size:$fs-medium
			color:$fc1
			padding-top:40px
			margin-right:4%
			span
				cursor:pointer
			.on
				color:$fc2
		.menuIcon
			display:none
@media screen and (max-width: 1500px)
	.tab
		.tabBox
			width:100%
			margin-left:0
			.logoWrapper
				width:25%
			.langWrapper
				margin-right:1%


@media screen and (max-width: 1200px)
	.tab
		.tabBox
			width:100% 
			margin-left:0
			.logoWrapper
				width:28%
				.text_notion
					font-size:$home-h3
			.langWrapper
				margin-right:1%
				font-size:$fs-medium
			.menuWrapper
				.routerWrapper
					.tab-item
						padding:0 8px
						.tab-link
							font-size:$fs-medium


@media screen and (max-width: 1000px) 
	.tab
		.tabBox
			min-width:$minWidth
			width:100%
			.menuWrapper
				min-width:1px
				.routerWrapper
					position:absolute
					top:60px
					left:0
					width:100%
					display:block
					display:none
					overflow:hidden
					.tab-item
						padding-left:30px
						background-color:$cb-e
						border-bottom:1px solid $cb-f
					.tab-item:hover
						&.tab-item
							background-image:none
							background-color:$fc2
							border-bottom:1px solid $cb-f
			.menuIcon
				display:block
				float:right
				width:60px
				line-height:56px
				font-weight:600
				font-size:$fs-large-x
				color:$fc1
				background-color:$fc2
				text-align:center

@media screen and (max-width: 410px)
	.tab
		.tabBox
			.logoWrapper
				width:15%
				min-width:175px
				margin-right:0
				img
					margin:4px 0
			.langWrapper
				margin-right:0
			.menuIcon
				width:55px

</style>


// WEBPACK FOOTER //
// src/base/tab/tab.vue